import { createPortal } from "react-dom";
import { useSyncExternalStore, type Ref } from "react";
import { getActiveOverlayPanel, subscribeOverlayLayers } from "./overlays/Overlay";
import { CloseIcon, InfoIcon, ShieldCheckIcon } from "./Icons";
import "../styles/toast.css";

export type ToastType = "success" | "error" | "info" | "warning";

export interface ToastProps {
  type: ToastType;
  message: string;
  onDismiss(): void;
}

export function Toast({ type, message, onDismiss }: ToastProps) {
  const Icon = type === "success" ? ShieldCheckIcon : type === "error" ? CloseIcon : InfoIcon;
  return (
    <div className={`shared-toast shared-toast--${type}`}>
      <Icon />
      <span className="shared-toast__message" role={type === "error" || type === "warning" ? "alert" : "status"} aria-atomic="true">
        <span className="sr-only">{type}: </span>{message}
      </span>
      <button type="button" onClick={onDismiss}>Dismiss</button>
    </div>
  );
}

export function ToastViewport({ toasts, onDismiss, targetRef }: {
  toasts: readonly { id: string; type: ToastType; message: string }[];
  onDismiss(id: string): void;
  targetRef?: Ref<HTMLElement>;
}) {
  const panel = useSyncExternalStore(subscribeOverlayLayers, getActiveOverlayPanel, () => null);
  return createPortal(
    <section ref={targetRef} className="shared-toast-viewport" aria-label="Notifications">
      {toasts.map((toast) => <Toast key={toast.id} type={toast.type} message={toast.message} onDismiss={() => onDismiss(toast.id)} />)}
    </section>,
    panel ?? document.body,
  );
}
